import React, { useContext, useRef, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useOnOutsideClick } from '@wix/da-hooks/pkg/useOnOutsideClick';
import { BiData } from '@wix/da-bi/pkg/events';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PlusIcon from '@wix/da-ds/pkg/Icons/Plus';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import WidgetTypeCard from './WidgetTypeCard';
import ZoneContext from '../../context/ZoneContext/ZoneContext';
import s from './AddWidget.scss';
const AddWidget = ({ position, installableWidgets, disabled })=>{
    const { t } = useTranslation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const zone = useContext(ZoneContext);
    if (!zone) {
        return null;
    }
    const rootRef = useRef(null);
    useOnOutsideClick([
        rootRef
    ], ()=>setIsMenuOpen(false), true);
    const openMenu = ()=>setIsMenuOpen(true);
    const closeMenu = ()=>setIsMenuOpen(false);
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "AddWidget",
        hideOnFail: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], disabled && s['disabled'], isMenuOpen && s['menu-is-open']),
        "data-role": "add-widget",
        ref: rootRef
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['line']
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        biData: isMenuOpen ? BiData({
            evid: 2,
            click_info: 'addWidget.close'
        }) : BiData({
            evid: 282
        }),
        onClick: ()=>{
            isMenuOpen ? closeMenu() : openMenu();
        },
        className: s['button-with-gradient-line']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['menu-toggle-btn']
    }, /*#__PURE__*/ React.createElement(PlusIcon, {
        className: s['plus-icon'],
        size: IconSize.SMALL
    }), t(!isMenuOpen ? 'gruser.layout.button.addWidget' : 'common.close'))), isMenuOpen && /*#__PURE__*/ React.createElement("div", {
        className: s['menu-container']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['menu'],
        "data-role": "menu"
    }, installableWidgets.map((installableWidget, index)=>{
        return /*#__PURE__*/ React.createElement("div", {
            className: s['menu-item'],
            key: index,
            onClick: ()=>{
                setIsMenuOpen(false);
            }
        }, /*#__PURE__*/ React.createElement(WidgetTypeCard, {
            position: position,
            installableWidget: installableWidget,
            zone: zone.name
        }));
    }))))));
};
AddWidget.displayName = 'AddWidget';
export default AddWidget;
